<template>
	<aside :class="classes">
		<header class="hide-small">
			<router-link :to="{ name: 'ReviewCourse', params: { courseId } }" tag="h1">
				{{ course.name }}
			</router-link>
		</header>

		<span class="menu-button" role="button" aria-label="Toggle menu" @click="toggleMenu">
			<IconMenu :width="32" :stroke="2" />
		</span>

		<nav :class="navClasses">
			<CourseTree v-model="course.children" mode="review" @change="$emit('change')" />
		</nav>

		<footer>
			<router-link :to="{ name: 'ReviewCourse', params: { courseId } }" aria-label="Overview">
				<IconList :width="24" :height="24" />
			</router-link>

			<BaseButton type="secondary" @click="previousGroup">
				<IconArrowLeft :width="24" :height="20" />
			</BaseButton>

			<BaseButton type="secondary" @click="nextGroup">
				<IconArrowRight :width="24" :height="20" />
			</BaseButton>
		</footer>
	</aside>
</template>

<script>
	import Store from '../inc/store';
	import BaseButton from './BaseButton';
	import IconArrowLeft from './icons/IconArrowLeft';
	import IconArrowRight from './icons/IconArrowRight';
	import IconMenu from './icons/IconMenu';
	import CourseTree from './CourseTree';
	import Bus from '../inc/bus';
	import {getNext, setCache} from '../inc/courseUtils';
	import sidebarMixin from '../mixins/sidebarMixin';
	import IconList from './icons/IconList.vue';

	export default {
		components: {
			BaseButton,
			IconArrowLeft,
			IconArrowRight,
			IconMenu,
			CourseTree,
			IconList
		},
		mixins: [sidebarMixin],
		computed: {
			course() {
				return Store.course;
			},
			courseId() {
				return Store.course.id || 0;
			},
			classes() {
				return 'sidebar course-sidebar' + (this.showMenu ? ' active' : '');
			},
			navClasses() {
				return 'sidebar-content hide-small' + (Store.courseMenuDragging ? ' dragging' : '');
			},
			groupId() {
				return Store.courseGroup.id;
			}
		},
		methods: {
			reloadMenu() {
				setCache(this.course);
			},
			startDragging() {
				Store.courseMenuDragging = true;
			},
			endDragging() {
				Store.courseMenuDragging = false;
			},
			showSettings() {
				Bus.emit('openCourseSettings', this.course.id);
			},
			nextGroup() {
				const groupId = getNext(this.groupId, 1, true);

				if(groupId) {
					this.$router.push({name: 'ReviewCourseGroup', params: {courseId: this.course.id, groupId}});
				}
			},
			previousGroup() {
				const groupId = getNext(this.groupId, -1, true);

				if(groupId) {
					if(groupId === this.courseId) {
						this.$router.push({name: 'ReviewCourse', params: {courseId: groupId}});
					}
					else {
						this.$router.push({name: 'ReviewCourseGroup', params: {courseId: this.course.id, groupId}});
					}
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	$_course_sidebar_item_height: $font__size * 2;
	$_course_sidebar_border_color: rgba(
		$color: $color__white,
		$alpha: 0.3,
	);

	.course-sidebar {
		user-select: none;
	}

	h1 {
		cursor: pointer;
	}

	header {
		padding: $sidebar__padding $sidebar__padding * 2;
		position: relative;
	}

	.progress-bar::v-deep {
		position: absolute;
		bottom: 0;
		left: 0;
		margin: 1.75em 0 0;
		width: 100%;
		background-color: $color__semi_white;

		& > div {
			color: $color__semi_white2;
			background-color: $color__white;

			span {
				top: -2em;
				font-size: 0.85rem;
			}
		}
	}

	.settings {
		position: absolute;
		left: $default_padding * 2;
		color: $color__semi_white2;
		cursor: pointer;

		&:hover {
			color: $color__white;
		}

		svg {
			display: block;
		}
	}

	footer::v-deep {
		gap: $default_padding;

		& > div, & > a {
			max-width: 100%;

			svg {
				margin: 0;
				display: block;
			}

			button {
				padding: 0;
			}
		}
	}
</style>